<div id="homepage" >

    <h2 *ngIf="evn.showWelcomeTitle" class="mt-5 font-weight-bolder"><i class="fa fa-user text-success font-size-h1"></i> {{ "HOME.WELCOME" | translate }}</h2>

    <div>
        <div class="card card-custom gutter-b">
            <div class="card-body py-0 px-0 rounded">
                <ngb-carousel>
                    <ng-template ngbSlide *ngFor="let item of slides$ | async; index as i;">
                        <div class="rounded">
                            <a href="javascript:void(0)" rel="nofollow noopener noreferrer">
                                <div class="picsum-img-wrapper">
                                <img src="/assets/media/slides/{{item.Imagen}}" alt="{{item.Titulo}}" >
                                </div>
                            </a>
                        </div>
                    </ng-template>
                  </ngb-carousel>
            </div>
        </div>

        <div class="row">
            <!-- "Monto":100.00,"IdTipoProceso":1,"TipoProceso":"Reclamos","Imagen":"Auto.png" -->
            <div *ngFor="let item of totalesRamos | async; index as i;" class="col-md-3">
                <div id="card-ramo-{{item.IdTipoProceso}}" class="card card-custom gutter-b mt-0 mb-10 card-ramo-{{item.IdTipoProceso}} card-ramos" (click)="onclickModalTotales(content, item.IdTipoProceso, item.TipoProceso )">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                                <div class="row align-items-center">
                                    <div class="col-4"><img src="/assets/media/icons/{{ item.Imagen }}" class="" width="100%" ></div>
                                    <div class="col-8 pl-0 pr-0 font-weight-boldest " style="font-size: 1.1em;">{{ item.Monto | currency:"$" }}</div>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12 mt-5" style="height: 50px;">
                                <div class="row">
                                    <div class="col-md-12  text-center"><a href="javascript:void(0)" class="btn btn-link font-size-h4 text-dark font-weight-boldest card-ramo-title" >{{ item.TipoProceso }}</a></div>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12 mt-5">
                                <div class="row  justify-content-md-center">
                                    <div class="col-md-12"><div class="separator separator-solid separator-border-2 separator-border-color" ></div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="totalesModal">
    <span *ngIf="closeResult">
      <pre>{{closeResult}}</pre>
    </span>
    <div>
    <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ tipoProceso }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="loading-totalesModal" *ngIf="loadingDetalleRamo">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>

            <div class="row" *ngIf="!loadingDetalleRamo">
                <div class="col-md-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="10%">&nbsp;</th>
                                <th width="60%" class="font-weight-bolder">{{ "HOME.DESCRIPTIONS" | translate }}</th>
                                <th class="font-weight-bolder">{{ "HOME.TOTAL" | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of detalleRamos | async; index as i">
                                <td><img src="/assets/media/icons/{{ item.Imagen }}" width="100%" ></td>
                                <td><span style="font-size: 1.1rem !important;">{{ item.Ramo}}</span></td>
                                <td><span class="label label-success label-inline mr-2 font-weight-bolder" style="font-size: 1.1rem !important;">{{ item.Monto | currency:"$" }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">Cerrar</button>
        </div>
    </ng-template>
  </div>